import React from 'react'
import Header from '../Component/Header';
import Body from '../Component/Body';

const Home = () => {

  
  return (
    <div>
      <Header/>
      <div >
      <Body/>
      </div>
    </div>
  )
}

export default Home;